import { html } from 'lit';

export const MindmapStyleOne = html`<svg
  width="64"
  height="48"
  viewBox="0 0 64 48"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect width="64" height="48" rx="4" />
  <path d="M23.976 24L43.4022 24" stroke="#E660A4" stroke-width="1.4" />
  <path
    d="M23.976 24.0001L26.5099 24.0001C30.4749 24.0001 33.6891 20.7858 33.6891 16.8208V16.8208C33.6891 12.8559 36.9034 9.6416 40.8684 9.6416L43.4022 9.6416"
    stroke="#6E52DF"
    stroke-width="1.4"
  />
  <path
    d="M23.976 24L26.5099 24C30.4749 24 33.6891 27.2143 33.6891 31.1792V31.1792C33.6891 35.1442 36.9034 38.3585 40.8684 38.3585L43.4022 38.3585"
    stroke="#FF8C38"
    stroke-width="1.4"
  />
  <g>
    <rect
      x="42.7023"
      y="33.4353"
      width="15.7585"
      height="9.84617"
      rx="2.38923"
      stroke="#FF8C38"
      stroke-width="1.4"
      shape-rendering="crispEdges"
    />
  </g>
  <g>
    <rect
      x="42.7023"
      y="19.0769"
      width="15.7585"
      height="9.84617"
      rx="2.38923"
      stroke="#E660A4"
      stroke-width="1.4"
      shape-rendering="crispEdges"
    />
  </g>
  <g>
    <rect
      x="42.7023"
      y="4.71846"
      width="15.7585"
      height="9.84617"
      rx="2.38923"
      stroke="#6E52DF"
      stroke-width="1.4"
      shape-rendering="crispEdges"
    />
  </g>
  <g>
    <rect
      x="5.53921"
      y="17.3879"
      width="18.2923"
      height="13.2246"
      rx="2.77776"
      stroke="#84CFFF"
      stroke-width="1.4"
      shape-rendering="crispEdges"
    />
  </g>
</svg> `;

export const MindmapStyleTwo = html`<svg
  width="64"
  height="48"
  viewBox="0 0 64 48"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M23.9761 24L43.4023 24"
    stroke="black"
    stroke-width="1.4"
    stroke-linejoin="round"
  />
  <path
    d="M23.9761 24.0001L33.5892 24.0001C33.6444 24.0001 33.6892 23.9553 33.6892 23.9001L33.6892 9.7416C33.6892 9.68637 33.7339 9.6416 33.7892 9.6416L43.4023 9.6416"
    stroke="black"
    stroke-width="1.4"
    stroke-linejoin="round"
  />
  <path
    d="M23.9761 24L33.5892 24C33.6444 24 33.6892 24.0448 33.6892 24.1L33.6892 38.2585C33.6892 38.3137 33.7339 38.3585 33.7892 38.3585L43.4023 38.3585"
    stroke="black"
    stroke-width="1.4"
    stroke-linejoin="round"
  />
  <g filter="url(#filter0_dd_7851_11431)">
    <rect
      x="43.4023"
      y="34.1353"
      width="14.3585"
      height="8.44617"
      rx="0.1"
      fill="#84CFFF"
    />
  </g>
  <g filter="url(#filter1_dd_7851_11431)">
    <rect
      x="43.4023"
      y="19.7769"
      width="14.3585"
      height="8.44617"
      rx="0.1"
      fill="#84CFFF"
    />
  </g>
  <g filter="url(#filter2_dd_7851_11431)">
    <rect
      x="43.4023"
      y="5.41846"
      width="14.3585"
      height="8.44617"
      rx="0.1"
      fill="#84CFFF"
    />
  </g>
  <g filter="url(#filter3_dd_7851_11431)">
    <rect
      x="6.23926"
      y="18.0879"
      width="16.8923"
      height="11.8246"
      rx="0.1"
      fill="#FFC46B"
    />
  </g>
  <defs>
    <filter
      id="filter0_dd_7851_11431"
      x="42.4023"
      y="33.1353"
      width="17.3585"
      height="11.4463"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feMorphology
        radius="1"
        operator="dilate"
        in="SourceAlpha"
        result="effect1_dropShadow_7851_11431"
      />
      <feOffset dx="1" dy="1" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_7851_11431"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feMorphology
        radius="1"
        operator="dilate"
        in="SourceAlpha"
        result="effect2_dropShadow_7851_11431"
      />
      <feOffset />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="effect1_dropShadow_7851_11431"
        result="effect2_dropShadow_7851_11431"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect2_dropShadow_7851_11431"
        result="shape"
      />
    </filter>
    <filter
      id="filter1_dd_7851_11431"
      x="42.4023"
      y="18.7769"
      width="17.3585"
      height="11.4463"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feMorphology
        radius="1"
        operator="dilate"
        in="SourceAlpha"
        result="effect1_dropShadow_7851_11431"
      />
      <feOffset dx="1" dy="1" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_7851_11431"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feMorphology
        radius="1"
        operator="dilate"
        in="SourceAlpha"
        result="effect2_dropShadow_7851_11431"
      />
      <feOffset />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="effect1_dropShadow_7851_11431"
        result="effect2_dropShadow_7851_11431"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect2_dropShadow_7851_11431"
        result="shape"
      />
    </filter>
    <filter
      id="filter2_dd_7851_11431"
      x="42.4023"
      y="4.41846"
      width="17.3585"
      height="11.4463"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feMorphology
        radius="1"
        operator="dilate"
        in="SourceAlpha"
        result="effect1_dropShadow_7851_11431"
      />
      <feOffset dx="1" dy="1" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_7851_11431"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feMorphology
        radius="1"
        operator="dilate"
        in="SourceAlpha"
        result="effect2_dropShadow_7851_11431"
      />
      <feOffset />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="effect1_dropShadow_7851_11431"
        result="effect2_dropShadow_7851_11431"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect2_dropShadow_7851_11431"
        result="shape"
      />
    </filter>
    <filter
      id="filter3_dd_7851_11431"
      x="5.23926"
      y="17.0879"
      width="19.8923"
      height="14.8247"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feMorphology
        radius="1"
        operator="dilate"
        in="SourceAlpha"
        result="effect1_dropShadow_7851_11431"
      />
      <feOffset dx="1" dy="1" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_7851_11431"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feMorphology
        radius="1"
        operator="dilate"
        in="SourceAlpha"
        result="effect2_dropShadow_7851_11431"
      />
      <feOffset />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="effect1_dropShadow_7851_11431"
        result="effect2_dropShadow_7851_11431"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect2_dropShadow_7851_11431"
        result="shape"
      />
    </filter>
  </defs>
</svg> `;

export const MindmapStyleThree = html`<svg
  width="64"
  height="48"
  viewBox="0 0 64 48"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path d="M23.976 24L43.4022 24" stroke="#FFD338" stroke-width="1.4" />
  <path
    d="M23.976 24.0001L26.5099 24.0001C30.4749 24.0001 33.6891 20.7858 33.6891 16.8208V16.8208C33.6891 12.8559 36.9034 9.6416 40.8684 9.6416L43.4022 9.6416"
    stroke="#FFD338"
    stroke-width="1.4"
  />
  <path
    d="M23.976 24L26.5099 24C30.4749 24 33.6891 27.2143 33.6891 31.1792V31.1792C33.6891 35.1442 36.9034 38.3585 40.8684 38.3585L43.4022 38.3585"
    stroke="#FFD338"
    stroke-width="1.4"
  />
  <g filter="url(#filter0_d_7851_6843)">
    <rect
      x="43.4023"
      y="34.1353"
      width="14.3585"
      height="8.44617"
      rx="1.68923"
      fill="white"
    />
    <rect
      x="42.7023"
      y="33.4353"
      width="15.7585"
      height="9.84617"
      rx="2.38923"
      stroke="#FFD338"
      stroke-width="1.4"
    />
  </g>
  <g filter="url(#filter1_d_7851_6843)">
    <rect
      x="43.4023"
      y="19.7769"
      width="14.3585"
      height="8.44617"
      rx="1.68923"
      fill="white"
    />
    <rect
      x="42.7023"
      y="19.0769"
      width="15.7585"
      height="9.84617"
      rx="2.38923"
      stroke="#FFD338"
      stroke-width="1.4"
    />
  </g>
  <g filter="url(#filter2_d_7851_6843)">
    <rect
      x="43.4023"
      y="5.41846"
      width="14.3585"
      height="8.44617"
      rx="1.68923"
      fill="white"
    />
    <rect
      x="42.7023"
      y="4.71846"
      width="15.7585"
      height="9.84617"
      rx="2.38923"
      stroke="#FFD338"
      stroke-width="1.4"
    />
  </g>
  <g filter="url(#filter3_d_7851_6843)">
    <rect
      x="6.23921"
      y="18.0879"
      width="16.8923"
      height="11.8246"
      rx="2.07776"
      fill="#FFD338"
    />
    <rect
      x="5.53921"
      y="17.3879"
      width="18.2923"
      height="13.2246"
      rx="2.77776"
      stroke="white"
      stroke-width="1.4"
    />
  </g>
  <defs>
    <filter
      id="filter0_d_7851_6843"
      x="39.4684"
      y="30.2015"
      width="22.2262"
      height="16.3138"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="1.26693" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_7851_6843"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_7851_6843"
        result="shape"
      />
    </filter>
    <filter
      id="filter1_d_7851_6843"
      x="39.4684"
      y="15.8431"
      width="22.2262"
      height="16.3138"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="1.26693" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_7851_6843"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_7851_6843"
        result="shape"
      />
    </filter>
    <filter
      id="filter2_d_7851_6843"
      x="39.4684"
      y="1.4847"
      width="22.2262"
      height="16.3138"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="1.26693" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_7851_6843"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_7851_6843"
        result="shape"
      />
    </filter>
    <filter
      id="filter3_d_7851_6843"
      x="2.30537"
      y="14.1541"
      width="24.76"
      height="19.6922"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="1.26693" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_7851_6843"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_7851_6843"
        result="shape"
      />
    </filter>
  </defs>
</svg> `;

export const MindmapStyleFour = html`<svg
  width="64"
  height="48"
  viewBox="0 0 64 48"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M23.9761 24L43.4023 24"
    stroke="#E660A4"
    stroke-width="1.4"
    stroke-linecap="round"
  />
  <path
    d="M23.9761 24.0001L26.5099 24.0001C30.4749 24.0001 33.6892 20.7858 33.6892 16.8208V16.8208C33.6892 12.8559 36.9034 9.6416 40.8684 9.6416L43.4023 9.6416"
    stroke="#6E52DF"
    stroke-width="1.4"
    stroke-linecap="round"
  />
  <path
    d="M23.9761 24L26.5099 24C30.4749 24 33.6892 27.2143 33.6892 31.1792V31.1792C33.6892 35.1442 36.9034 38.3585 40.8684 38.3585L43.4023 38.3585"
    stroke="#FF8C38"
    stroke-width="1.4"
    stroke-linecap="round"
  />
  <path
    d="M7 26C9.85124 21.8236 11.8347 18.5607 11.8347 20.649C11.8347 22.7372 10.9669 24.695 11.2149 25.3475C11.4628 26 12.9504 24.0423 13.9421 22.8677C14.9339 21.6931 15.9256 21.0405 15.8017 22.8677C15.6777 24.6949 16.2975 25.739 17.2893 24.8254C18.281 23.9118 19.2727 23.5203 20.0165 23.7813C20.6116 23.9901 21.5868 24.5644 22 24.8254"
    stroke="black"
    stroke-width="1.4"
    stroke-linecap="round"
  />
  <path
    d="M44 11C46.4711 7.51964 48.1901 4.80062 48.1901 6.54079C48.1901 8.28097 47.438 9.91246 47.6529 10.4562C47.8678 11 49.157 9.36862 50.0165 8.38977C50.876 7.41092 51.7355 6.86712 51.6281 8.38977C51.5207 9.91243 52.0579 10.7825 52.9174 10.0212C53.7769 9.25986 54.6364 8.93358 55.281 9.1511C55.7967 9.32512 56.6419 9.80367 57 10.0212"
    stroke="black"
    stroke-width="1.4"
    stroke-linecap="round"
  />
  <path
    d="M44 25.5C46.4711 22.0196 48.1901 19.3006 48.1901 21.0408C48.1901 22.781 47.438 24.4125 47.6529 24.9562C47.8678 25.5 49.157 23.8686 50.0165 22.8898C50.876 21.9109 51.7355 21.3671 51.6281 22.8898C51.5207 24.4124 52.0579 25.2825 52.9174 24.5212C53.7769 23.7599 54.6364 23.4336 55.281 23.6511C55.7967 23.8251 56.6419 24.3037 57 24.5212"
    stroke="black"
    stroke-width="1.4"
    stroke-linecap="round"
  />
  <path
    d="M44 40C46.4711 36.5196 48.1901 33.8006 48.1901 35.5408C48.1901 37.281 47.438 38.9125 47.6529 39.4562C47.8678 40 49.157 38.3686 50.0165 37.3898C50.876 36.4109 51.7355 35.8671 51.6281 37.3898C51.5207 38.9124 52.0579 39.7825 52.9174 39.0212C53.7769 38.2599 54.6364 37.9336 55.281 38.1511C55.7967 38.3251 56.6419 38.8037 57 39.0212"
    stroke="black"
    stroke-width="1.4"
    stroke-linecap="round"
  />
</svg> `;
